import { render, staticRenderFns } from "./TableAlunosReposicao.vue?vue&type=template&id=34c6cd0f&scoped=true"
import script from "./TableAlunosReposicao.vue?vue&type=script&lang=js"
export * from "./TableAlunosReposicao.vue?vue&type=script&lang=js"
import style0 from "./TableAlunosReposicao.vue?vue&type=style&index=0&id=34c6cd0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6cd0f",
  null
  
)

export default component.exports